// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1w-1I","topBottomGutter":"Layout_topBottomGutter__2Mjw2"};